import { render, staticRenderFns } from "./ticket-prices-edit.vue?vue&type=template&id=31f1d673&scoped=true&"
import script from "./ticket-prices-edit.vue?vue&type=script&lang=js&"
export * from "./ticket-prices-edit.vue?vue&type=script&lang=js&"
import style0 from "./ticket-prices-edit.vue?vue&type=style&index=0&id=31f1d673&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f1d673",
  null
  
)

export default component.exports